var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"team-trash"}},[_c('PageTitle',{attrs:{"title":_vm.$t('team.trash.caption')}}),_c('PageTitle',{attrs:{"title":_vm.$t('common.team') + ' | ',"prefix":""}}),_c('h1',[_vm._v(_vm._s(_vm.$t('team.trash.caption')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }